import ajax from "@/lib/ajax";
/**
 * 读取腹透中心当前月情况汇总表
 */
export async function GetNursingQualityControlReporList() {
    let res = await ajax.get(`/api/services/app/PDNursingQualityControlRepor/GetNursingQualityControlReporList`);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdQualityControlManage/pdNursingQualityControlRepor/index.ts